module.exports = __webpack_public_path__ + "static/media/upward.9c898851.webp";